import styled from '@emotion/styled';
import React from 'react';
import { MergeWithOverwrite } from 'src/common';
import { colors } from 'src/theme';

const IconSpan = styled.span((props: { height: number; width: number }) => ({
  display: 'inline-flex',
  height: props.height,
  width: props.width,
}));

export type CloseIconProps = MergeWithOverwrite<React.HtmlHTMLAttributes<HTMLSpanElement>,{
  width?: number;
  height?: number;
  color?: string;
}>;

export const CloseIcon: React.FC<CloseIconProps> = ({ width = 16, height = 16, color = colors.primary, ...props }) => (
  <IconSpan {...props} height={height} width={width}>
    <svg width={width} height={height} viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="Group">
        <path
          id="Union"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M9.14642 9.85349L9.85345 9.14645L5.70697 4.99997L9.85345 0.853485L9.14642 0.146454L4.99994 4.29294L0.853455 0.146454L0.146423 0.853485L4.29291 4.99997L0.146423 9.14645L0.853455 9.85349L4.99994 5.707L9.14642 9.85349Z"
          fill={color}
        />
      </g>
    </svg>
  </IconSpan>
);
